import { useQuery, useMutation } from '@tanstack/react-query';
import { logsApi } from '../services/api';

export const useLogGroups = () =>
  useQuery({
    queryKey: ['logGroups'],
    queryFn: () => logsApi.getLogGroups(),
  });

export const useSimpleSearch = () =>
  useMutation({
    mutationFn: (params) => logsApi.simpleSearch(params),
  });

export const useInsightsQuery = () =>
  useMutation({
    mutationFn: (params) => logsApi.runInsightsQuery(params),
  });

export const useLogPatterns = () => {
  const abortControllerRef = { current: null };

  const mutation = useMutation({
    mutationFn: (params) => {
      const controller = new AbortController();
      abortControllerRef.current = controller;
      return logsApi.analyzePatterns(params, controller.signal);
    },
    onSettled: () => {
      abortControllerRef.current = null;
    },
  });

  const cancel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
      mutation.reset();
    }
  };

  return { ...mutation, cancel };
};
